<!--
 * @FileDescription: 其他收支（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-21（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="freight-top" @click="onAdd(1)" v-has="'system_other_revenexpen_add'">
                <img src="@/assets/image/feright-add.png"/>
                <span>新增收支类别</span>
            </div>
            <div class="line"></div>
            <div class="adjustment-table">
                <div class="adjustment-table-item" @click="clickTab(1)" :class="tabIndex == 1 ? 'adjustment-table-item-active' :''">
                    <img src="@/assets/image/qitashouru.png" v-if="tabIndex == 1"/>
                    <img src="@/assets/image/shouru.png" v-else />
                    <span>其他收入类别</span>
                </div>
                <div class="adjustment-line"></div>
                <div class="adjustment-table-item" @click="clickTab(2)" :class="tabIndex == 2 ? 'adjustment-table-item-active' :''">
                    <img src="@/assets/image/zhichu(2).png" v-if="tabIndex == 2"/>
                    <img src="@/assets/image/qitazhichu.png" v-else />
                    <span>其他支出类别</span>
                </div>
            </div>
            <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     class="table-freight"
                     bordered
                     rowKey="key">
                <template slot="operation" slot-scope="text, record,index">
                    <div style="display: flex" v-if="!isEmpty(record.companyStoreId)">
                        <span style="color: #387BFC;margin-right: 20px;cursor: pointer" @click="onAdd(2,record)" v-has="'system_other_revenexpen_edit'" >编辑</span>
                        <div class="operation-item" v-has="'system_other_revenexpen_delete'" >
                            <a-popconfirm
                                    v-if="dataSource.length"
                                    title="确定删除?"
                                    @confirm="() => onDelete(record.id)"
                            >
                                <a href="javascript:;" >
                                    <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                                    <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                                </a>
                            </a-popconfirm>
                        </div>
                    </div>
                </template>
            </a-table>
        </div>
        <freightModel ref="freightModel" @onPageList="onPageList"></freightModel>
    </div>
</template>

<script>
    import {financeList,financeDelete} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import freightModel from './model/freightModel'
    export default {
        mixins:[mixins],
        data(){
            return{
                tabIndex:1,
                columns: [
                    {
                        title: '',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 80,
                        align: 'center',
                        customRender(t, r, index) {
                            return parseInt(index) + 1
                        }
                    },
                    {
                        title: '类别编号',
                        key: 'code',
                        dataIndex: 'code',
                    },
                    {
                        title: '类别名称',
                        key: 'name',
                        dataIndex: 'name',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        scopedSlots: { customRender: 'operation' }
                    },
                ],
                dataSource: [],
                dataSource1:[],
            }
        },
        watch: {

        },
        mounted () {
            this.getList()
        },
        created () {

        },
        components: {
            freightModel,

        },
        methods: {
            getList(){
                this.$store.state.isLoding = true
                let data = {
                    type:this.tabIndex,
                    companyStoreId : this.$store.state.shopId,
                    companyId : this.$store.state.companyId
                }
                data =   this.$qs.stringify(data)
                financeList(data,{}).then((res)=>{
                    if(res.success){
                       this.dataSource = res.result
                        this.$store.state.isLoding = false
                    }
                })
            },
            /**
             * @description: 此为方法注释（方法描述）
             * @param {参数类型} 参数名称
             * @return void
             */
            clickTab(index){
                this.tabIndex = index
                this.getList()
            },
            onAdd(index,record){
                if(this.tabIndex == 1){
                    let data = {
                        type:'2',
                        companyStoreId : this.$store.state.shopId,
                        companyId : this.$store.state.companyId
                    }
                    data =   this.$qs.stringify(data)
                    financeList(data,{}).then((res)=>{
                        if(res.success){
                            this.dataSource1 = res.result
                        }
                    })
                    this.$refs.freightModel.onOpen(1,record,index,parseInt(this.dataSource[0].code)+1,parseInt(this.dataSource1[0].code)+1)
                }else{
                    let data = {
                        type:'1',
                        companyStoreId : this.$store.state.shopId,
                        companyId : this.$store.state.companyId
                    }
                    data =   this.$qs.stringify(data)
                    financeList(data,{}).then((res)=>{
                        if(res.success){
                            this.dataSource1 = res.result
                        }
                    })
                    this.$refs.freightModel.onOpen(1,record,index,parseInt(this.dataSource1[0].code)+1,parseInt(this.dataSource[0].code)+1)
                }
            },
            onPageList(){
                this.getList()
            },
            /**
             * @description: 删除（方法描述）
             */
            onDelete(id){
                let data = {id:id}
                data =   this.$qs.stringify(data)
                financeDelete(data,{}).then((res)=>{
                    if(res.success){
                        this.getList()
                    }
                })
            },
        },

    }
</script>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    overflow-x: hidden;
    .freight-top{
        cursor: pointer;
        width: 200px;
        padding: 20px 0 20px 30px;
        color: var(--co);
        img{
            width: 40px;
            margin-right: 8px;
        }
    }
    .adjustment-line{
        width: 1px;
        height: 18px;
        background: #919191;
        margin-top: 5px;
        margin-right: 32px;
    }

}
</style>


